<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Sales
            Navigator campaign</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>

      </div>

    </base-header>


    <div v-if="this.$store.getters.getHaveAccount" class="container-fluid mt--6">
      <card>
        <div ref="paypal"></div>
      </card>
    </div>

  </div>

</template>

<script>
import RouteBreadCrumb from '@/components/Argon/Breadcrumb/RouteBreadcrumb';
import swal from 'sweetalert2';

export default {
  name: "upgradeplan",
  components: {
    RouteBreadCrumb,
  },
  data() {
    return {
      order: {
        description: "Buy thing",
        amount: {
          currency_code: "USD",
          value: 50
        }
      }
    };
  },
  mounted: function () {
    const script = document.createElement("script");
    const ClientID = "AbhT_gna6c04doSzthFOCvCZtRtiygX5Drf2OVvwtuY78uszcYYh42NZzoxOmyAbSF3kz25wJbOLsjc6";
    script.src = `https://www.paypal.com/sdk/js?client-id=${ClientID}`;
    // script.src = `https://api-m.sandbox.paypal.com/sdk/js?client-id=${ClientID}`;
    script.addEventListener("load", this.setLoaded);
    document.body.appendChild(script);
  },
  methods: {
    setLoaded: function () {
      window.paypal
        .Buttons({
          createOrder: (data, actions) => {
            return actions.order.create({
              purchase_units: [this.order]
            });
          },
          onApprove: async (data, actions) => {
            const order = await actions.order.capture();
            if (order['status'] === "COMPLETED") {
              swal.fire({
                title: `Thank you ${this.$store.getters.getUser}`,
                html:
                  '<p>Thank you for your purchase, let us propelling you in the direction of your destiny.</p>',
                confirmButtonText: 'Continue',
                confirmButtonClass: 'btn btn-warning',
                icon: 'success'
              });
            }
          },
          onError: err => {
            console.log(err);
          }
        })
        .render(this.$refs.paypal);
    }
  }
};
</script>
